<script>
import RAF from 'raf'
import TWEEN from 'tween.js'
import Animator from './utils/animator'
import AppFooter from '@/components/AppFooter'

RAF(function tick() {
	TWEEN.update()
	Animator.update()
	RAF(tick)
})

export default {
	name: 'app',
	components: {
		AppFooter,
	}
}
</script>


<template>
<div id="app">
	<keep-alive>
		<router-view></router-view>
	</keep-alive>
	<app-footer></app-footer>
</div>
</template>



<style lang="less">
@import './styles/fonts.less';

body {
	margin: 0;
	padding: 0;
	outline: none;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-size: 16px;
	font-family: @fontGrotesk;
	background: #090909;
}

.clearfix:after {
	content: "";
	display: table;
	clear: both;
}

// #app {
// 	width: 100%;
// 	height: 100%;
// 	position: absolute;
// 	overflow: hidden;
// }
</style>



// WEBPACK FOOTER //
// App.vue?8e7603e2